import { MapLocation } from '@/types/location';

export const qassimDigitalMegacomScreens: MapLocation[] = [
  {
    id: 10082,
    name: "Digital Megacom Screen – Qassim",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.092056, 43.997583],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/f9df2bb6-16dc-459a-af6a-ba39644947cb.png"
    }
  },
  {
    id: 10083,
    name: "Digital Megacom Screen – Qassim 2",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.061917, 43.982361],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/95455388-fa80-40b7-91f9-528a2c877529.png"
    }
  },
  {
    id: 10084,
    name: "Digital Megacom Screen – Qassim 3",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.090778, 43.987806],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/2dac4a21-982e-426f-89b2-608985650826.png"
    }
  },
  {
    id: 10085,
    name: "Digital Megacom Screen – Qassim 4",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.106186, 43.998167],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/e238bad0-ea33-4cd9-afa3-1c8aed553960.png"
    }
  },
  {
    id: 10086,
    name: "Digital Megacom Screen – Qassim 5",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.062600, 43.981889],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/80950af1-97fe-4508-ba3d-9d448c1674d8.png"
    }
  },
  {
    id: 10087,
    name: "Digital Megacom Screen – Qassim 6",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.392533, 43.926692],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/9f9259a7-2388-4de9-95b9-9fb23a3f40d0.png"
    }
  },
  {
    id: 10088,
    name: "Digital Megacom Screen – Qassim 7",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.369472, 43.925778],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/512ea696-9578-4695-add1-0d18379463ca.png"
    }
  },
  {
    id: 10089,
    name: "Digital Megacom Screen – Qassim 8",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.311972, 44.018944],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/973eba07-40f6-4069-9bc2-25e53e58aca9.png"
    }
  },
  {
    id: 10090,
    name: "Digital Megacom Screen – Qassim 9",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.394167, 43.929444],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/e2ac732e-df31-4eaa-ba8f-b689c9ea1c88.png"
    }
  },
  {
    id: 10091,
    name: "Digital Megacom Screen – Qassim 10",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.375111, 43.943361],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/5b83b1af-e87c-4d90-ac7c-92cddea5b4b9.png"
    }
  },
  {
    id: 10092,
    name: "Digital Megacom Screen – Qassim 11",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.403472, 43.914500],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/02935fa3-190b-4d35-9a5e-0dc251f979c5.png"
    }
  },
  {
    id: 10093,
    name: "Digital Megacom Screen – Qassim 12",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.363306, 43.907556],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/4b148255-2c36-4072-872b-cd432d915d69.png"
    }
  },
  {
    id: 10094,
    name: "Digital Megacom Screen – Qassim 13",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.413833, 43.915611],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/b5356e34-62f9-4db8-b49d-0bac5e2193c2.png"
    }
  },
  {
    id: 10095,
    name: "Digital Megacom Screen – Qassim 14",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.423639, 43.911167],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/dfcc2b7a-c3ec-42a1-8762-18b71df31bd7.png"
    }
  },
  {
    id: 10096,
    name: "Digital Megacom Screen – Qassim 15",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.391333, 43.921361],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/3def4778-afa9-44e5-9db1-5ef93b0bcd44.png"
    }
  },
  {
    id: 10097,
    name: "Digital Megacom Screen – Qassim 16",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.309750, 43.969472],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/43e0dd58-a0e5-4365-b731-625b83a0690d.png"
    }
  },
  {
    id: 10098,
    name: "Digital Megacom Screen – Qassim 17",
    type: "Digital Megacom",
    devices: 1,
    coordinates: [26.322686, 43.994417],
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital megacom screen with 1 face\nPrice: 1,286 SAR per face per day",
      screenDimensions: "4m x 3m",
      referenceImage: "/images/f8b92a84-6b54-40d7-8171-1c6ca4580304.png"
    }
  }
];
